export const getShouldAutoScroll = () => !(window?.innerHeight && window.innerWidth < 450)
